module.exports = __webpack_public_path__ + "static/company-progress-dadc18a7425db852a24691f7e188ce86.jpg";